// UNCOMMENT IF DRUPAL - see components/_meta/_01-foot.twig for attachBehaviors
// Drupal.behaviors.accordion = {
//   attach: function (context, settings) {

(function () { // REMOVE IF DRUPAL

  'use strict';

   var headingMenu = document.querySelector('.hero .hero-menu-trigger');

   headingMenu.addEventListener('click', function(e){
     var className = 'triggered';
     var menuClassName = 'is-open';

     if (this.classList) {
       this.classList.toggle(className);
       this.parentNode.nextElementSibling.classList.toggle(menuClassName);
     }
     else {
       var classes = this.className.split(' ');
       var contentClasses = this.parentNode.nextElementSibling.className.split(' ');
       var existingIndex = classes.indexOf(className);
       var existingContentIndex = contentClasses.indexOf(menuClassName);

       if (existingIndex >= 0) {
         classes.splice(existingIndex, 1);
         contentClasses.splice(existingContentIndex, 1);
       }
       else {
         classes.push(className);
         contentClasses.push(menuClassName);
       }
       this.className = classes.join(' ');
       this.menuClassName = contentClasses.join(' ');
     }
     e.preventDefault();
   });

})(); // REMOVE IF DRUPAL

// UNCOMMENT IF DRUPAL
//   }
// };
